"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetUserPhotoRequest = void 0;
var GetUserPhotoRequest = /** @class */ (function () {
    function GetUserPhotoRequest() {
    }
    return GetUserPhotoRequest;
}());
exports.GetUserPhotoRequest = GetUserPhotoRequest;
;
//# sourceMappingURL=getUserPhoto.request.js.map